export default __webpack_public_path__ + "static/media/wybuch_wyniki.25590df1.gif";